/**
 * Única fuente de verdad para la identidad, el contacto y las condiciones
 * comerciales publicadas en la web.
 *
 * REGLA: aquí sólo se escriben datos REALES confirmados. Ningún dato
 * identificativo (domicilio, forma jurídica, identificación fiscal, registro)
 * se publica hasta que exista y sea facilitado por Growthly Corporation
 * Systems. No se añaden marcadores de posición.
 *
 * NOTA: Growthly Corporation Systems es actualmente un proyecto y servicio en
 * fase de prueba y validación comercial. No se presenta como sociedad
 * constituida en ningún texto de la web.
 */
export const COMPANY = {
  /** Denominación utilizada en toda la web. */
  legalName: 'Growthly Corporation Systems',
  /** Marca corta para logotipo y navegación. */
  brand: 'GROWTHLY',
  supportEmail: 'hola@growthly-co-sys.com',
  phone: '+34 674 826 914',
  whatsappUrl: 'https://wa.me/34674826914',
} as const
export const OFFER = {
  name: 'Growthly Digital Solution',
  summary: 'Proyecto completo · Pago único',
  price: 350,
  currency: 'EUR',
  currencyLabel: '350 € (EUR)',
  /**
   * La fiscalidad definitiva depende del país de facturación y se determinará
   * en el proceso de pago. No se afirma que el IVA español esté incluido.
   */
  taxNotice:
    'Los impuestos aplicables se determinan según el país de facturación del cliente y se muestran antes de confirmar el pago.',
  deliveryEstimate:
    'Entre dos y cuatro semanas desde que disponemos de la información y los materiales necesarios.',
  included: [
    'Página web profesional a medida',
    'Carta digital lista para consultar',
    'Diseño responsive para cada pantalla',
    'Gestión y mantenimiento integral',
    'Actualizaciones y soporte continuo',
    'Sin cuotas mensuales ni costes ocultos',
  ],
} as const
export const LEGAL_LINKS = [
  {
    href: '/terminos',
    label: 'Términos y condiciones',
  },
  {
    href: '/privacidad',
    label: 'Política de privacidad',
  },
  {
    href: '/reembolsos',
    label: 'Política de reembolsos',
  },
] as const
